import { atom } from "recoil";
import Auth from "types/Auth";

// 로그인 인증 전역 상태
const authAtom = atom<Auth>({
  key: "loginAuth",
  default: {
    type: "",
    isLogin: false,
  },
});

export default authAtom;
